import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Badge, Layout, Menu, notification, Tooltip, } from "antd";
import styles from "./CenterMenu.module.scss";
import { useTranslation } from "react-i18next";
import { AppContext } from "src/pages/context/App.context";
import * as Auth from "src/service/auth.service";
import {
    checkEmpty,
    getNameProfile,
    getPathWss,
    getUrlHttp,
    isTrue,
    loadCitizenJsToSessionStorage,
} from "src/service/util.service";
import logo_img from "src/assets/png/mainLogo.png";
import arrowRight from "src/assets/png/arrowRight.png";
import arrowLeft from "src/assets/png/arrowLeft.png";
import SvgFeedIconNew from "src/components/icon/SvgFeedIconNew";
import SvgHomeIconNew from "src/components/icon/SvgHomeIconNew";
import SvgProfileIconNew from "src/components/icon/SvgProfileIconNew";
import SvgAppIconNew from "src/components/icon/SvgAppIconNew";
import SvgGroupIconNew from "src/components/icon/SvgGroupIconNew";
import SvgLinkPersonalIconNew from "src/components/icon/SvgLinkPersonalIconNew";
import SvgGearIconNew from "src/components/icon/SvgGearIconNew";
import SvgHomeCaseManagement from "src/components/icon/SvgHomeCaseManagement";
import SvgSettingCaseManagement from "src/components/icon/SvgSettingCaseManagement";

//new icon
import ActionCenterBlue from "src/assets/png/newIcon/Main menu/Blue/ActionCenterBlue.png";
import CitizenProfileBlue2 from "src/assets/png/newIcon/Main menu/Blue/CitizenProfileBlue2.png";
import MyAppBlue from "src/assets/png/newIcon/Main menu/Blue/MyAppBlue.png";
import MyCenterBlue from "src/assets/png/newIcon/Main menu/Blue/MyCenterBlue.png";
import MyGroupBlue from "src/assets/png/newIcon/Main menu/Blue/MyGroupBlue.png";
import SettingBlue from "src/assets/png/newIcon/Main menu/Blue/SettingBlue.png";
import HomeFeedBlue from "src/assets/png/newIcon/Main menu/Blue/HomeFeedBlue.png";
import photoCamera from "src/assets/png/photo-camera.png";
import * as Props from "../../../props/util.props";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { pathRoutes } from "src/props/util.props";
import useFetch, { CachePolicies } from "use-http";
import { UserAPIEndpoint } from "src/service/user.service";
// import {getFirebaseApp} from "../../../push-notification";
import * as serviceWorker from "../../../serviceWorker";
import IncomingCallModal from "src/pages/videoCall/videoCall/IncomingCallModal";
import { JanusAPIEndpoint } from "src/service/janus.service";
import BoxDetailFileDownload from "src/pages/filePage/component/download/BoxDetailFileDowload";
import useWindowDimensions from "src/components/shared/CustomHooks/useWindowDimensions";
import { setJanusServerURL } from "src/service/config.service";
import { EventType, VideoCallState } from "src/utils/janus.utils";
import Iconkeypost from "../../../assets/png/Iconkeypost.png";
import { v4 as uuidv4 } from "uuid";
import Lightbox from "react-image-lightbox";
import { hide, lightbox, moveNext, movePrev, } from "src/features/lightbox/lightboxSlice";
import { setId, setImgURL, setName, setUsername, } from "src/features/profile/profileSlice";
import { useAppDispatch, useAppSelector } from "src/hooks";
import { call, canceledCallEvent, incomingCallEvent, rejectedCallEvent, } from "src/features/call/callSlice";
import useSound from "use-sound";

// @ts-ignore
import ringtone from "../../../assets/audio/ringtone-2.mp3";
import { getMessaging, onMessage } from "firebase/messaging";
import { getFirebaseApp, onForegroundMessage } from "../../../firebase";
import { useQuery } from "@tanstack/react-query";
import { getCustomMenu } from "../../../service/apps.service";
import FsLightbox from "fslightbox-react";
import { DesktopOutlined, FileOutlined, PieChartOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons";

const { Header, Footer, Sider, Content } = Layout;
let webSocket: any = null;

export const CenterMenu = (props: any) => {
    const { t, i18n } = useTranslation();
    const { height, width } = useWindowDimensions();

    const [play, { stop }] = useSound(ringtone);

    let navigate = useNavigate();
    const appContext: any = useContext(AppContext);
    const [imgUrlProfile, setImgUrlProfile] = useState(
        "https://i.pinimg.com/474x/1e/14/d8/1e14d8400ffd25ad6a397f0c9d23acb5.jpg"
    );
    const [nameProfile, setNameProfile] = useState("Li Xiaoyao Ammyyyyy");
    const [usernameProfile, setUsernameProfile] = useState("@LiXiaoyao");
    // const [payload, setPayload] = useState(null);
    const [imageProfileURL, setImageProfileURL] = useState(
        "https://www.w3schools.com/howto/img_avatar.png"
    );
    const [displayName, setDisplayName] = useState("");
    // const [custom, sett_custom] = useState([]);
    const [callEvent, setCallEvent] = useState<any>();

    const isDestroy = useRef<boolean>(false);

    const { isOpen, images, currentIndex } = useAppSelector(lightbox);
    const callState = useAppSelector(call);

    const dispatch = useAppDispatch();

    const location = useLocation();

    const [displayCz, setDisplayCz] = useState(window.__RUNTIME_CONFIG__.REACT_APP_CZ);


    useLayoutEffect(() => {
        var x = document.getElementsByTagName("BODY")[0];
        if (!x) return

        x.addEventListener("microAppEvt", async (event: any) => {
            if (event?.detail?.data?.type === "native") {
                if (event?.detail?.data?.id === "file") {
                    appContext.setMainMenuActive(pathRoutes.Apps);
                    navigate(pathRoutes.File);
                } else if (event?.detail?.data?.id === "chat") {
                    appContext.setMainMenuActive(pathRoutes.Apps);
                    navigate(pathRoutes.Chat);
                }
            } else if (event?.detail?.data?.type === "microApp") {
                appContext.setMainMenuActive(pathRoutes.Apps);
                navigate(pathRoutes.MicroAppPD + "?app=" + event?.detail?.data?.id, {
                    state: { item: event?.detail?.data }
                });
            }
        });

    }, []);

    const {
        data: customMenu,
    } = useQuery(["custom-menu"], getCustomMenu, {
        retry: 10,
        onSuccess: (data) => {
            sessionStorage.setItem(
                "custom_menu",
                JSON.stringify(data.customlink)
            );
            // console.log("custom_menu", data.customlink)
            if (location.pathname === pathRoutes.Home || location.pathname === "/") {
                let customMenuObj = data.customlink;
                const customHome = customMenuObj.find(
                    (menu: any) => menu?.key === "home" && menu?.type === "custom"
                );
                if (customHome) {
                    navigate(pathRoutes.CustomMenu + "/" + customHome?.key, {
                        state: { res: customHome },
                    });
                }
            }
        }
    })

    useEffect(() => {
        if (!customMenu) return;
        if (location.pathname === pathRoutes.Home || location.pathname === "/") {
            let customMenuObj: any = customMenu?.customlink || null;
            const customHome = customMenu?.customlink.find(
                (menu: any) => menu?.key === "home" && menu?.type === "custom"
            );
            if (customHome) {
                navigate(pathRoutes.CustomMenu + "/" + customHome?.key, {
                    state: { res: customHome },
                });
            }
        }
    }, [customMenu])

    const janusCallReject = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + JanusAPIEndpoint.Call + "/reject",
        {
            method: "post",
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const janusCallAccept = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + JanusAPIEndpoint.Call + "/accept",
        {
            method: "post",
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );
    //
    // const apiCustomMenu = useFetch(
    //     window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/custom-menu/",
    //     {
    //         cachePolicy: CachePolicies.NO_CACHE,
    //     }
    // );

    const apiActionCenter = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/action",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const loadAction = async () => {
        try {
            let lastdate = new Date();
            const stringLastDate = new Date(lastdate).toISOString();
            const res = await apiActionCenter.get(
                `/?limit=20&date=${stringLastDate}`
            );
            // console.log("Action:333");

            if (apiActionCenter.response.ok) {
                // console.log("Action: ${res}", res);
                // appContext?.setActionCount(res?.total);
                appContext?.setActions(res.data);
                appContext?.setActionCount(res?.countUnRead);
                // console.log("xxx123");
                appContext?.setActionTotal(res?.total);
            }
        } catch (error) {
        }
    };

    const setDataUser = async () => {
        // if (checkEmpty(appContext.profile)) {
        const me = await api.get(UserAPIEndpoint.Me);

        console.log("me == > Unauthorized", me);
        if (me?.status === "Unauthorized") {
            console.log("me == > Unauthorized");
            Auth.resetToken(false);
            navigate(pathRoutes.Root);
        }
        if (checkEmpty(me)) return;
        setUsernameProfile(me?.id);
        setNameProfile(getNameProfile(me?.firstname, me?.lastname));
        console.log("me.imageProfileURL : ", me?.imageProfileURL);

        setImgUrlProfile(getUrlHttp(me?.imageProfileURL));
        // appContext.setProfile({
        //   usernameProfile: me?.id,
        //   username: me?.username,
        //   nameProfile:
        //   getNameProfile(me?.firstname,me?.lastname),
        //   imgUrlProfile: me?.imageProfileURL,
        // });
        dispatch(setId(me?.id));
        dispatch(setUsername(me?.username));
        dispatch(setName(getNameProfile(me?.firstname, me?.lastname)));
        dispatch(setImgURL(me?.imageProfileURL));
        // }
    };

    useEffect(() => {
        loadCitizenJsToSessionStorage();
        console.log("setInterval updateSessionTime==")
        Auth.updateSessionTimeApi("Y");
        setInterval(function () {
            Auth.updateSessionTimeApi("Y");
        }, 600000);
        window.addEventListener("unload", (event) => {
            Auth.updateSessionTimeApi("N");
          });
    }, []);

    // useEffect(() => {
    //     if (sessionStorage.getItem("custom_menu")) {
    //         const Json1 = sessionStorage.getItem("custom_menu");
    //         let obj = JSON.parse(Object(Json1));
    //         sett_custom(obj);
    //
    //         if (location.pathname === pathRoutes.Home || location.pathname === "/") {
    //             let customMenuObj = obj;
    //             const customHome = customMenuObj.find(
    //                 (menu: any) => menu?.key === "home" && menu?.type === "custom"
    //             );
    //             if (customHome) {
    //                 props.navigate({
    //                     pathname: pathRoutes.CustomMenu + "/" + customHome?.key,
    //                     state: {res: customHome},
    //                 });
    //             } else {
    //                 navigate(pathRoutes.Home);
    //             }
    //         }
    //     } else {
    //         loadMenu();
    //     }
    // }, []);

    // const loadMenu = async () => {
    //     const response = await apiCustomMenu.get();
    //     if (apiCustomMenu.response.ok) {
    //         sessionStorage.setItem(
    //             "custom_menu",
    //             JSON.stringify(response.customlink)
    //         );
    //         sett_custom(response.customlink);
    //         if (location.pathname === pathRoutes.Home || location.pathname === "/") {
    //             let customMenuObj = response.customlink;
    //             const customHome = customMenuObj.find(
    //                 (menu: any) => menu?.key === "home" && menu?.type === "custom"
    //             );
    //             if (customHome) {
    //                 props.navigate({
    //                     pathname: pathRoutes.CustomMenu + "/" + customHome?.key,
    //                     state: {res: customHome},
    //                 });
    //             }
    //         }
    //         console.log("custom menu response", JSON.stringify(response.customlink));
    //     } else {
    //     }
    // };

    //call notification web socket
    useEffect(() => {
        if (!appContext.objectAccesses) return;
        if (!appContext.objectAccesses?.["PERSONAL_MAIN_CALL"]) return;
        if (!appContext.objectAccesses?.["GROUP_MAIN_CALL"]) return;
        const currentCallState = appContext.videoCallState;

        if (currentCallState !== VideoCallState.Idle) {
            isDestroy.current = true;
            try {
                webSocket.close();
            } catch (e) {
            }
            return;
        }

        const ReconnectTime = 2000;
        const token = Auth.getToken();

        let pathUrl = getPathWss(window.__RUNTIME_CONFIG__.REACT_APP_CENTER_STREAM_WS);
        const socketUrl = `${pathUrl}/?userId=${Auth.getUserData()?.id
            }&token=${token}`;

        console.log("Socket URL", socketUrl);

        function connect() {
            isDestroy.current = false;
            try {
                webSocket.close();
            } catch (e) {
            }
            webSocket = new WebSocket(socketUrl);
            webSocket.onopen = () => {
                console.log(":: [Video call connected]");
            };
            webSocket.onclose = (e: any) => {
                console.log(":: [Video call closed]", e.reason);
                if (isDestroy.current) return;
                setTimeout(() => {
                    connect();
                }, ReconnectTime);
            };
            webSocket.onmessage = (msg: any) => {
                const msgData = JSON.parse(msg?.data);
                console.log(":: [Video call message]", msgData);

                setCallEvent(msgData);
            };
        }

        connect();
        return () => {
            try {
                webSocket.close();
            } catch (e) {
            }
            isDestroy.current = true;
            console.log(":: call is closed now");
        };
    }, [appContext.videoCallState, appContext.objectAccesses]);

    // useEffect(() => {
    //   if (!appContext.objectAccesses) return;
    //   if (!appContext.objectAccesses["PERSONAL_MAIN_CALL"]) return;
    //   if (!appContext.objectAccesses["GROUP_MAIN_CALL"]) return;
    //
    //   const status = callState.status;
    //
    //   if (status !== UserStatus.AVAILABLE) {
    //     isDestroy.current = true;
    //     try {
    //       webSocket.close();
    //     } catch (e) {}
    //     return;
    //   }
    //
    //   const ReconnectTime = 2000;
    //   const token = Auth.getToken();
    //
    //   let pathUrl = getPathWss(window.__RUNTIME_CONFIG__.REACT_APP_CENTER_STREAM_WS);
    //   const socketUrl = `${pathUrl}/?userId=${
    //       Auth.getUserData()?.id
    //   }&token=${token}`;
    //
    //   console.log("Socket URL", socketUrl);
    //
    //   function connect() {
    //     isDestroy.current = false;
    //     try {
    //       webSocket.close();
    //     } catch (e) {}
    //     webSocket = new WebSocket(socketUrl);
    //     webSocket.onopen = () => {
    //       console.log(":: [Video call connected]");
    //     };
    //     webSocket.onclose = (e: any) => {
    //       console.log(":: [Video call closed]", e.reason);
    //       if (isDestroy.current) return;
    //       setTimeout(() => {
    //         connect();
    //       }, ReconnectTime);
    //     };
    //     webSocket.onmessage = (msg: any) => {
    //       const msgData = JSON.parse(msg?.data);
    //       console.log(":: [Video call message]", msgData);
    //
    //       setCallEvent(msgData);
    //     };
    //   }
    //
    //   connect();
    //   return () => {
    //     try {
    //       webSocket.close();
    //     } catch (e) {}
    //     isDestroy.current = true;
    //     console.log(":: call is closed now");
    //   };
    // }, [callState.status, appContext.objectAccesses]);

    useEffect(() => {
        if (!callEvent) return;
        // if (!callEvent?.connectionID) return;
        // if (appContext?.callPayload?.connectionID === callEvent?.connectionID) return;

        console.log("[callEvent]", callEvent);

        switch (callEvent?.eventType) {
            case EventType.StartCalling:
                dispatch(incomingCallEvent(callEvent));
                appContext.setCallPayload(callEvent);
                break;
            case EventType.Cancel:
                dispatch(canceledCallEvent(callEvent));
                appContext.setCanceledPayload(callEvent);
                break;
            case EventType.Reject:
                dispatch(rejectedCallEvent(callEvent));
                appContext.setRejectedPayload(callEvent);
                break;
        }
    }, [callEvent]);

    //action notification web socket
    useEffect(() => {
        const ReconnectDuration = 2000;
        let isDestroy = false;
        const token = Auth.getToken();
        let pathUrl = window.__RUNTIME_CONFIG__.REACT_APP_CENTER_WS;
        pathUrl = getPathWss(pathUrl);
        const socketUrl = `${pathUrl}/?id=${Auth.getUserData()?.id}&token=${token}`;
        let webSocket: any = null;

        function connect() {
            webSocket = new WebSocket(socketUrl);
            webSocket.onopen = () => {
                console.log(":: action center connected");
            };
            webSocket.onclose = (e: any) => {
                console.log(":: action center closed", e.reason);
                if (isDestroy) return;
                setTimeout(() => {
                    connect();
                }, ReconnectDuration);
            };
            webSocket.onmessage = (msg: any) => {
                const msgData = JSON.parse(msg?.data);
                // appContext?.setActionCount(msgData?.count);
                console.log("sss1235");
                loadAction();
                // console.log("Action msgData => ",msgData);
                // appContext?.setActionTotal(appContext?.actionTotal+1)
            };
        }

        connect();
        loadAction();
        return () => {
            webSocket?.close();
            isDestroy = true;
            console.log(":: action center is closed now");
        };
    }, []);

    useEffect(() => {
        setDataUser();
        return () => {
            janusCallReject.abort();
        };
    }, []);


    useEffect(() => {
        appContext.setMainMenuActive(location.pathname)
    }, [])

    const openNotification = (title: any, message: any, data: any) => {
        let key = uuidv4();
        notification.info({
            key: key,
            message: title,
            description: message,
            placement: "bottomRight",
            // duration: 300,
            icon: (
                <div style={{ backgroundColor: "#0f4c82" }}>
                    <img className={styles.mainLogoMenu} src={logo_img} />
                </div>
            ),
            className: styles.pushnoti,
            onClick: () => {
                console.log("click noti");
                // notification.close(key);
                if (checkEmpty(data.customClick)) {
                    navigate(pathRoutes.Feed);
                } else {
                    // window.open(data.customClick,"_self")
                    if (data?.appName == "CaseManagement") {
                        navigate(Props.pathRoutes.CaseDetails + "/" + data?.instanceId + `?stageId=${data?.stageId}&stepId=${data?.stepId}`)
                    }
                }
            },
        });
    };

    /*
    useEffect(() => {
        onForegroundMessage()
            .then((payload: any) => {
                console.log('Received foreground message: ', payload);
                const {notification: {title, body}} = payload;
                console.log("Message received. ", payload);
                const data = payload?.data;
                if (data?.isCall) {
                    if (!data?.cancelCall && !data.rejectCall) {
                        appContext.setCallPayload(data);
                    } else if (data?.cancelCall) {
                        appContext.setCanceledPayload(data);
                    } else if (data?.rejectCall) {
                        appContext.setRejectedPayload(data);
                    }
                } else if (isTrue(data?.isCommon)) {
                    openNotification(
                        payload?.notification?.title,
                        payload?.notification?.body,
                        data
                    );
                }

            })
            .catch(err => console.log('An error occured while retrieving foreground message. ', err))
            .finally(()=>{
                console.log("finally onForegroundMessage")
                // serviceWorker.unregister();
            })
    }, []);
    */

    useEffect(() => {
        // if(appContext.initFirebase === false){
        //   initializeFirebase();
        //   appContext.setInitFirebase(true)
        // }
        try {
            let firebaseApp: any = getFirebaseApp();
            // console.log("firebaseApp: ", firebaseApp);
            // if (checkEmpty(firebaseApp));
            const messaging: any = getMessaging(firebaseApp)
            onMessage(messaging, (payload) => {
                console.log("Message received. ", payload);
                const data = payload?.data;
                if (data?.isCall) {
                    if (!data?.cancelCall && !data.rejectCall) {
                        appContext.setCallPayload(data);
                    } else if (data?.cancelCall) {
                        appContext.setCanceledPayload(data);
                    } else if (data?.rejectCall) {
                        appContext.setRejectedPayload(data);
                    }
                } else if (isTrue(data?.isCommon)) {
                    openNotification(
                        payload?.notification?.title,
                        payload?.notification?.body,
                        data
                    );
                }
            });
            // serviceWorker.unregister();
        } catch (e) {
            console.log("firebase err", e);
        }
    }, []);

    useEffect(() => {
        const payload = appContext.callPayload;
        if (!payload) return;
        if (appContext.videoCallState !== VideoCallState.Idle) {
            let rejectObj = {
                userId: payload?.username,
                callRoom: parseInt(payload?.callRoom),
                connectionId: payload?.connectionID,
            };
            console.log("rejectObj: ", rejectObj);
            console.log("current payload", payload);
            janusCallReject.post(rejectObj).then((res) => {
                console.log("reject response: ", res);
            });
            return;
        }

        appContext.setIncomingCall(true);
        appContext.setConnectionID(payload?.connectionID);
        setImageProfileURL(payload?.image);
        setDisplayName(payload?.displayName);
    }, [appContext.callPayload]);

    useEffect(() => {
        const payload = appContext.canceledPayload;
        if (!payload) return;
        if (appContext.connectionID === payload?.connectionID) {
            if (appContext.videoCallState !== VideoCallState.Accepted) {
                appContext.setVideoCallState(VideoCallState.Idle);
            }
            appContext.setIncomingCall(false);
        }
    }, [appContext.canceledPayload]);

    useEffect(() => {
        const payload = appContext.rejectedPayload;
        if (!payload) return;
        appContext.setVideoCallState(VideoCallState.Idle);
    }, [appContext.rejectedPayload]);

    // useEffect(() => {
    //     const payload = appContext.callPayload;
    //     console.log("Payload", payload);
    //     //@ts-ignore
    //     if (payload?.isCall) {
    //         //@ts-ignore
    //         if (!payload?.cancelCall && !payload.rejectCall) {
    //             if (appContext.videoCallState !== VideoCallState.Idle) {
    //                 let rejectObj = {
    //                     //@ts-ignore
    //                     userId: payload?.username,
    //                     //@ts-ignore
    //                     callRoom: parseInt(payload?.callRoom),
    //                     //@ts-ignore
    //                     connectionId: payload?.connectionID,
    //                 };
    //                 console.log("rejectObj: ", rejectObj);
    //                 console.log("current payload", payload);
    //                 janusCallReject.post(rejectObj).then((res) => {
    //                     console.log("reject response: ", res);
    //                 });
    //                 return;
    //             }
    //
    //             appContext.setIncomingCall(true);
    //             // appContext.setVideoCallState("incoming");
    //             //@ts-ignore
    //             appContext.setConnectionID(payload?.connectionID);
    //             //@ts-ignore
    //             setImageProfileURL(payload?.image);
    //             //@ts-ignore
    //             setDisplayName(payload?.displayName);
    //             //@ts-ignore
    //         } else if (payload?.rejectCall) {
    //             console.log("Reject call");
    //             appContext.setVideoCallState(VideoCallState.Idle);
    //             appContext.setRejectedPayload(payload);
    //             //@ts-ignore
    //         } else if (payload?.cancelCall) {
    //             console.log("Cancel call");
    //             //@ts-ignore
    //             if (appContext.connectionID === payload?.connectionID) {
    //                 if (appContext.videoCallState !== VideoCallState.Accepted) {
    //                     appContext.setVideoCallState(VideoCallState.Idle);
    //                 }
    //                 appContext.setIncomingCall(false);
    //                 // setPayload(null);
    //             }
    //         }
    //     }
    // }, [appContext.callPayload]);

    useEffect(() => {
        setUsernameProfile(appContext.profile?.usernameProfile);
    }, [appContext.profile?.usernameProfile]);
    useEffect(() => {
        setImgUrlProfile(appContext.profile?.imgUrlProfile);
    }, [appContext.profile?.imgUrlProfile]);
    useEffect(() => {
        setNameProfile(appContext.profile?.nameProfile);
    }, [appContext.profile?.nameProfile]);

    useEffect(() => {
        setJanusServerURL();
    }, []);

    useEffect(() => {
        if (appContext.incomingCall) {
            play();
        } else {
            stop();
        }
    }, [appContext.incomingCall]);
    //
    // useEffect(() => {
    //   if (!appContext.isPendingCall || appContext.videoCallState !== null || appContext.incomingCall) return;
    //
    //   const payload = appContext.callPayload;
    //
    //   appContext.setIsPendingCall(false);
    //   appContext.setVideoCallState("accepted");
    //
    //   navigate(
    //       pathRoutes.personalCall +
    //       "?id=" +
    //       //@ts-ignore
    //       payload.groupID +
    //       "&isReceive=true" +
    //       "&isVideoCall=" +
    //       //@ts-ignore
    //       payload.isVideoCall
    //   );
    //
    // }, [appContext.isPendingCall, appContext.videoCallState, appContext.incomingCall])

    const handleRejectCall = () => {
        const payload = appContext.callPayload;
        appContext.setVideoCallState(VideoCallState.Idle);
        appContext.setIncomingCall(false);
        let rejectObj = {
            //@ts-ignore
            userId: payload?.username,
            //@ts-ignore
            callRoom: parseInt(payload?.callRoom),
            //@ts-ignore
            connectionId: payload?.connectionID,
        };
        console.log("rejectObj: ", rejectObj);
        console.log("current payload", payload);
        janusCallReject.post(rejectObj).then((res) => {
            console.log("reject response: ", res);
        });
        appContext.setCallPayload(null);
        appContext.setConnectionID(null);
        // navigate(pathRoutes.Chat+"?id=" + "lol");
    };

    const handleAcceptCall = () => {
        const payload = appContext.callPayload;

        if (appContext.videoCallState !== VideoCallState.Idle) {
            appContext.setIsPendingCall(true);
            appContext.setIncomingCall(false);
            appContext.setCallPayload(null);
            return;
        }

        // appContext.setVideoCallState("accepted");
        console.log("connection id", payload?.connectionID);
        appContext.setConnectionID(payload?.connectionID);
        appContext.setIncomingCall(false);

        let acceptObj = {
            userId: payload?.username,
            callRoom: parseInt(payload?.callRoom),
            connectionId: payload?.connectionID,
            deviceID: localStorage.getItem("device_token"),
        };
        janusCallAccept.post(acceptObj).then((res) => {
            console.log("accept response: ", res);
        });

        navigate(
            pathRoutes.personalCall +
            "?id=" +
            payload?.groupID +
            "&isReceive=true" +
            "&isVideoCall=" +
            payload?.isVideoCall +
            "&calleeId=" +
            payload?.username +
            "&callRoom=" +
            payload?.callRoom +
            "&connectionID=" +
            payload?.connectionID
        );
    };

    const handleCollapMenu = (value: any) => {
        appContext.setCollapedMenu(value);
    };
    const handleClickMenu = (value: any) => {
        console.log("handleClickMenu : ", value);
        appContext.setMenuActive(value);
        if (value === Props.ActionsCenterMenu) {
        } else if (value === Props.NewsfeedMenu) {
            navigate(pathRoutes.Feed);
        } else if (value === Props.ProfileMenu) {
        } else if (value === Props.GroupMenu) {
            navigate(pathRoutes.Group);
        } else if (value === Props.AllAppsMenu) {
        } else if (value === Props.SettingMenu) {
        } else if (value === Props.LinkPersonalMenu) {
        }
    };

    const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
        cachePolicy: CachePolicies.NO_CACHE,
    });
    const handleUploadImage = async (event: any) => {
        const file = event.target?.files?.[0];
        if (file) {
            const data = new FormData();
            data.append("file", file);
            data.append("bucket", "profile");

            await api.post("api/v1/files/profile", data);
            if (api.response.ok) {
                const url = URL.createObjectURL(file);
                setImgUrlProfile(url);
                appContext.setProfile({
                    imgUrlProfile: url,
                    usernameProfile: appContext.profile?.usernameProfile,
                    nameProfile: appContext.profile?.nameProfile,
                    username: appContext.profile?.username,
                });
                console.log("uploaded profile image.");
            } else {
                notification["warning"]({
                    message: t("Upload image error") + ".",
                    description:
                        t("Can not use this image") +
                        ", " +
                        t("please select another file") +
                        ".",
                });
            }
        }
    };

    const leftMenuCollapHtml = (
        <div className={styles.leftMenu}>
            <div
                onClick={() => {
                    handleCollapMenu(false);
                }}
                className={styles.boxArrowPosionCollaped}
            >
                <img className={styles.iconArrow} src={arrowLeft} />
            </div>
            <div className={styles.profileMiniBox}>
                <div>
                    {/* HideNotComplete*/}
                    {/*<Input*/}
                    {/*  className={styles.searchBox}*/}
                    {/*  placeholder={t("Search")}*/}
                    {/*  prefix={<SvgSearchIcon width={12} height={12} color={"#BEBEBE"} />}*/}
                    {/*  allowClear*/}
                    {/*/>*/}
                </div>
                <div>
                    <div className={styles.boxProfileDetailMini}>
                        <div style={{ width: "100px" }}>
                            <div className={styles.cameraPosition}>
                                <div className={styles.imgCameraBox}>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        style={{
                                            width: "15px",
                                            height: "17px",
                                            position: "absolute",
                                            opacity: "0",
                                            cursor: "pointer",
                                            zIndex: 1,
                                        }}
                                        onChange={handleUploadImage}
                                    />
                                    <div
                                        className={styles.imgCamera}
                                        style={{
                                            backgroundImage: `url(${photoCamera})`,
                                        }}
                                    ></div>
                                </div>
                            </div>
                            <div
                                style={{
                                    backgroundImage: `url(${imgUrlProfile})`,
                                }}
                                className={styles.personalImg}
                            ></div>
                        </div>
                        <div className={styles.boxNameDetail}>
                            <div className={styles.textOverText}>
                                <div className={styles.nameOfProfile}>{nameProfile}</div>
                            </div>
                            <div className={styles.textOverText}>
                                <div className={styles.usernameOfProfile}>
                                    {usernameProfile}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* HideNotComplete*/}
                {/*<div style={{ paddingTop: "25px", position: "relative" }}>*/}
                {/*  <input*/}
                {/*    type="file"*/}
                {/*    accept="image/*"*/}
                {/*    style={{*/}
                {/*      width: "15px",*/}
                {/*      height: "13px",*/}
                {/*      position: "absolute",*/}
                {/*      opacity: "0",*/}
                {/*      cursor: "pointer",*/}
                {/*      zIndex: 1,*/}
                {/*      right: 0,*/}
                {/*    }}*/}
                {/*    onChange={handleUploadImage}*/}
                {/*  />*/}
                {/*  <div*/}
                {/*    className={styles.imgCamera}*/}
                {/*    style={{*/}
                {/*      float: "right",*/}
                {/*      backgroundImage: `url(${photoCamera})`,*/}
                {/*    }}*/}
                {/*  ></div>*/}
                {/*</div>*/}
                <div></div>
            </div>
            <div className={styles.boxMenuCollped}>
                <CustomLinkIconText to={pathRoutes.Feed} activeOnlyWhenExact={false}>
                    <div>
                        <div style={{ alignItems: "center" }}>
                            <img style={{ width: 20, height: 20 }} src={ActionCenterBlue} />
                        </div>
                        <div className={styles.menuName}>{t("Action Center")}</div>
                    </div>
                </CustomLinkIconText>
                <CustomLinkIconText to={pathRoutes.Home} activeOnlyWhenExact={false}>
                    <div>
                        <div style={{ alignItems: "center" }}>
                            <img style={{ width: 20, height: 20 }} src={HomeFeedBlue} />
                        </div>
                        <div className={styles.menuName}>{t("Home")}</div>
                    </div>
                </CustomLinkIconText>
                <CustomLinkIconText to={pathRoutes.Profile} activeOnlyWhenExact={false}>
                    <div>
                        <div style={{ alignItems: "center" }}>
                            <img style={{ width: 20, height: 20 }} src={MyCenterBlue} />
                        </div>
                        <div className={styles.menuName}>{t("Profile")}</div>
                    </div>
                </CustomLinkIconText>
                <CustomLinkIconText to={pathRoutes.Apps} activeOnlyWhenExact={false}>
                    <div>
                        <div style={{ alignItems: "center" }}>
                            <img style={{ width: 20, height: 20 }} src={MyAppBlue} />
                        </div>
                        <div className={styles.menuName}>{t("All apps")}</div>
                    </div>
                </CustomLinkIconText>
                <CustomLinkIconText to={pathRoutes.Group} activeOnlyWhenExact={false}>
                    <div>
                        <div style={{ alignItems: "center" }}>
                            <img style={{ width: 20, height: 20 }} src={MyGroupBlue} />
                        </div>
                        <div className={styles.menuName}>{t("Group")}</div>
                    </div>
                </CustomLinkIconText>

                {isTrue(displayCz) && (
                    <CustomLinkIconText
                        to={pathRoutes.citizenprofile}
                        activeOnlyWhenExact={false}
                    >
                        <div>
                            <div style={{ alignItems: "center" }}>
                                <img
                                    style={{ width: 20, height: 20 }}
                                    src={CitizenProfileBlue2}
                                />
                            </div>
                            <div className={styles.menuName}>
                                {t("ONEWEB Citizen Profile")}
                            </div>
                        </div>
                    </CustomLinkIconText>
                )}

                <CustomLinkIconTextGear
                    to={pathRoutes.Setting}
                    activeOnlyWhenExact={false}
                >
                    <div style={{ width: "230px", justifyContent: "center" }}>
                        <div style={{ alignItems: "center" }}>
                            <img style={{ width: 20, height: 20 }} src={SettingBlue} />
                        </div>
                        <div className={styles.menuName}>{t("Setting")}</div>
                    </div>
                </CustomLinkIconTextGear>
            </div>
        </div>
    );

    function getItem(
        label: React.ReactNode,
        key: React.Key,
        icon?: React.ReactNode,
        children?: any,
    ) {
        return {
            key,
            icon,
            children,
            label,
        };
    }


    const items = [
        getItem('Option 1', '1', <PieChartOutlined />),
        getItem('Option 2', '2', <DesktopOutlined />),
        getItem('User', 'sub1', <UserOutlined />, [
            getItem('Tom', '3'),
            getItem('Bill', '4'),
            getItem('Alex', '5'),
        ]),
        getItem('Team', 'sub2', <TeamOutlined />, [getItem('Team 1', '6'), getItem('Team 2', '8')]),
        getItem('Files', '9', <FileOutlined />),
    ];
    const [collapsed, setCollapsed] = useState<boolean>(checkEmpty(sessionStorage.getItem("collapsed_menu")) ? true : sessionStorage.getItem("collapsed_menu") === "true");

    useEffect(() => {
        sessionStorage.setItem("collapsed_menu", String(collapsed));
    }, [collapsed]);

    const onClickMenu = (e: any) => {
        console.log('click ', e);
        // setCurrent(e.key);
    };

    const defaultMenuIcons = [
        {
            key: "action-center",
            value: <SvgFeedIconNew width={20} height={20} />
        },
        {
            key: "home",
            value: <SvgHomeIconNew width={20} height={20} />
        },
        {
            key: "home-case-management",
            value: <SvgHomeCaseManagement width={20} height={20} />
        },
        {
            key: "setting-case-management",
            value: <SvgSettingCaseManagement width={20} height={20} />
        },
        {
            key: "profile",
            value: <SvgProfileIconNew width={20} height={20} />
        },
        {
            key: "apps",
            value: <SvgAppIconNew width={20} height={20} />
        },
        {
            key: "groups",
            value: <SvgGroupIconNew width={20} height={20} />
        },
        {
            key: "citizenprofile",
            value: <SvgLinkPersonalIconNew
                width={20}
                height={20}
            />
        }
    ]

    const [current, setCurrent] = useState("");

    useEffect(() => {

        if (location) {
            if (current !== location.pathname) {
                // console.log("location.pathname", location.pathname);
                setCurrent(location.pathname);
            }
        }
    }, [location, current]);

    const onNavigate = (value: string, state: any = null) => {
        appContext.setMainMenuActive(value)
        if (state) navigate(value, state);
        else navigate(value);
    }
    const getCssIcon = (key: any) => {

        if (key != appContext.mainMenuActive) {
            return [styles.iconMenu, styles.iconMenuNotActive].join(" ");
        } else {
            return [styles.iconMenu, styles.iconMenuActive].join(" ");
        }
        // return [styles.iconMenu].join(" ");
    }



    return (
        <>
            <Layout className={[styles.overrideLayout].join(" ")}>
                <Sider theme={collapsed ? "dark" : "dark"} collapsedWidth={56}
                    style={{
                        background: collapsed ? '#0f4c82' : "rgb(9, 50, 87)",
                        borderRight: "1px solid rgba(255, 255, 255, 0.1)"
                    }}
                    collapsible
                    collapsed={collapsed}
                    onCollapse={() => setCollapsed(!collapsed)}>
                    <div style={{
                        display: "flex",
                        background: '#0f4c82',
                        justifyContent: "center",
                        alignItems: "center",
                        height: 50,
                        width: "100%",
                    }}>
                        <img className={styles.mainLogoMenu} src={logo_img} />
                    </div>

                    {customMenu?.customlink &&
                        <Menu style={{ background: collapsed ? '#0f4c82' : "rgb(9, 50, 87)" }}
                            theme={collapsed ? "dark" : "dark"} defaultSelectedKeys={[current]} mode="inline">
                            {customMenu?.customlink?.map((item: any, idx: number) => {
                                if (item?.type === "default") {
                                    if (item?.key === "post") {
                                        return <Menu.Item
                                            key={"/" + "posts"}
                                            title={t(item.name)}
                                            style={{ padding: collapsed ? "4px 14px" : "", paddingLeft: "14px" }}
                                            className={(getCssIcon("/posts"))}
                                            icon={
                                                <Badge size={"small"}
                                                    style={{
                                                        lineHeight: "14px",
                                                        maxWidth: "26px",
                                                        display: "flex",
                                                        fontSize: "10px",
                                                        justifyContent: "center"
                                                    }}
                                                    count={item.key === "action-center" ? appContext?.actionCount || 0 : 0}
                                                    overflowCount={99}
                                                >
                                                    {item?.iconType === "url" ?
                                                        <img
                                                            src={item?.icon}
                                                            alt="new"
                                                            style={{
                                                                width: "20px",
                                                                height: "20px",
                                                            }}
                                                        /> :
                                                        item?.iconType === "url" ? <span role="img" style={{ width: "20px", height: "100%" }}
                                                            className="anticon ant-menu-item-icon"
                                                            dangerouslySetInnerHTML={{
                                                                __html: item?.icon,
                                                            }}></span> :
                                                            <span role="img" style={{ width: "20px", height: "100%" }}
                                                                className="anticon ant-menu-item-icon">
                                                                <img
                                                                    src={Iconkeypost}
                                                                    alt="new"
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                    }}
                                                                />
                                                                {/* <SvgHomeIconNew width={20} height={20} /> */}
                                                            </span>
                                                    }
                                                </Badge>
                                            }
                                            onClick={() => onNavigate(pathRoutes.Post)}
                                        >
                                            {t(item.name)}
                                        </Menu.Item>

                                    }
                                    return <Menu.Item
                                        key={"/" + item.key}
                                        title={t(item.name)}
                                        style={{ padding: collapsed ? "4px 14px" : "", paddingLeft: "14px" }}
                                        className={(getCssIcon("/" + item?.key))}
                                        icon={
                                            <Badge size={"small"}
                                                style={{
                                                    lineHeight: "14px",
                                                    maxWidth: "26px",
                                                    display: "flex",
                                                    fontSize: "10px",
                                                    justifyContent: "center"
                                                }}
                                                count={item.key === "action-center" ? appContext?.actionCount || 0 : 0}
                                                overflowCount={99}
                                            >
                                                <span role="img" style={{ width: "20px", height: "100%" }}
                                                    className="anticon ant-menu-item-icon">
                                                    {defaultMenuIcons.find((icon: any) => icon.key === item.key)?.value ||
                                                        <SvgHomeIconNew width={20} height={20} />}
                                                </span>
                                            </Badge>
                                        }
                                        onClick={() => onNavigate("/" + item.key)}
                                    >
                                        {t(item.name)}
                                    </Menu.Item>
                                } else if (item?.type === "custom") {
                                    if (item?.key === "post") {
                                        return <Menu.Item
                                            key={"/" + "posts"}
                                            title={t(item.name)}
                                            style={{ padding: collapsed ? "4px 14px" : "", paddingLeft: "14px" }}
                                            className={(getCssIcon("/posts"))}
                                            icon={
                                                <Badge size={"small"}
                                                    style={{
                                                        lineHeight: "14px",
                                                        maxWidth: "26px",
                                                        display: "flex",
                                                        fontSize: "10px",
                                                        justifyContent: "center"
                                                    }}
                                                    count={item.key === "action-center" ? appContext?.actionCount || 0 : 0}
                                                    overflowCount={99}
                                                >
                                                    {item?.iconType === "url" ?
                                                        <img
                                                            src={item?.icon}
                                                            alt="new"
                                                            style={{
                                                                width: "20px",
                                                                height: "20px",
                                                            }}
                                                        /> :
                                                        item?.iconType === "url" ? <span role="img" style={{ width: "20px", height: "100%" }}
                                                            className="anticon ant-menu-item-icon"
                                                            dangerouslySetInnerHTML={{
                                                                __html: item?.icon,
                                                            }}></span> :
                                                            <span role="img" style={{ width: "20px", height: "100%" }}
                                                                className="anticon ant-menu-item-icon">
                                                                <img
                                                                    src={Iconkeypost}
                                                                    alt="new"
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                    }}
                                                                />
                                                                {/* <SvgHomeIconNew width={20} height={20} /> */}
                                                            </span>
                                                    }
                                                </Badge>
                                            }
                                            onClick={() => onNavigate(pathRoutes.Post)}
                                        >
                                            {t(item.name)}
                                        </Menu.Item>

                                    }
                                    return <Menu.Item
                                        key={"/" + item.key}
                                        title={t(item.name)}
                                        style={{ padding: collapsed ? "4px 14px" : "", paddingLeft: "14px" }}
                                        className={(checkEmpty(item?.link) ? getCssIcon("/" + item?.key) : getCssIcon(pathRoutes.CustomMenu + "/" + item?.key))}
                                        icon={
                                            <Badge size={"small"}
                                                style={{
                                                    lineHeight: "14px",
                                                    maxWidth: "26px",
                                                    display: "flex",
                                                    fontSize: "10px",
                                                    justifyContent: "center"
                                                }}
                                                count={item.key === "action-center" ? appContext?.actionCount || 0 : 0}
                                                overflowCount={99}
                                            >
                                                {item?.iconType === "url" ?
                                                    <img
                                                        src={item?.icon}
                                                        alt="new"
                                                        style={{
                                                            width: "20px",
                                                            height: "20px",
                                                        }}
                                                    /> : !checkEmpty(item?.icon) ?

                                                        <span role="img" style={{ width: "20px", height: "100%" }}
                                                            className="anticon ant-menu-item-icon"
                                                            dangerouslySetInnerHTML={{
                                                                __html: item?.icon,
                                                            }}></span>
                                                        :
                                                        <span role="img" style={{ width: "20px", height: "100%" }}
                                                            className="anticon ant-menu-item-icon">
                                                            {defaultMenuIcons.find((icon: any) => icon.key === item.key)?.value ||
                                                                <SvgHomeIconNew width={20} height={20} />}
                                                        </span>
                                                }
                                            </Badge>
                                        }
                                        onClick={() => {
                                            if (checkEmpty(item?.link)) {
                                                onNavigate("/" + item.key)
                                            } else {
                                                onNavigate(pathRoutes.CustomMenu + "/" + item?.key, {
                                                    state: { res: item }
                                                })
                                            }
                                        }}
                                    >
                                        {t(item.name)}
                                    </Menu.Item>
                                }
                            }
                            )
                            }
                            <Menu.Item
                                key={"/setting"}
                                title={t("Setting")}
                                style={{ padding: collapsed ? "4px 14px" : "", paddingLeft: "14px" }}
                                className={(getCssIcon("/setting"))}
                                icon={
                                    <Badge size={"small"}
                                        style={{
                                            lineHeight: "14px",
                                            maxWidth: "26px",
                                            display: "flex",
                                            fontSize: "10px",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <span role="img" style={{ width: "20px", height: "100%" }}
                                            className="anticon ant-menu-item-icon">
                                            <SvgGearIconNew width={20} height={20} />
                                        </span>
                                    </Badge>
                                }
                                onClick={() => onNavigate(pathRoutes.Setting)}
                            >
                                {t("Setting")}
                            </Menu.Item>
                        </Menu>
                    }
                </Sider>
                {isOpen && (
                    <Lightbox
                        wrapperClassName={styles.lightboxOverride}
                        mainSrc={images[currentIndex].src}
                        nextSrc={
                            currentIndex < images.length - 1
                                ? images[currentIndex + 1].src
                                : undefined
                        }
                        prevSrc={
                            currentIndex !== 0 ? images[currentIndex - 1].src : undefined
                        }
                        onCloseRequest={() => dispatch(hide())}
                        onMovePrevRequest={() => dispatch(movePrev())}
                        onMoveNextRequest={() => dispatch(moveNext())}
                        reactModalStyle={{ backgroundColor: "#fff" }}
                    />
                )}
                <Layout
                    className={["site-layout", styles.overrideLayout].join(" ")}
                    style={{
                        marginLeft:
                            appContext.collapedMenu && window.innerWidth > 600
                                ? 230
                                : 0,
                        height: "100vh",
                    }}
                >
                    {/* {props.showHeader ? (
          <Header
            className={["site-layout-background", styles.overrideHeader]}
            style={{ padding: 0 }}
          >
            <Input
              className={styles.searchBoxHeader}
              placeholder={t("Search")}
              prefix={<SvgSearchIcon width={12} height={12} color={"white"} />}
              onChange={props.callBackSeachHeader}
              allowClear
            />
          </Header>
        ) : (
          <></>
        )} */}
                    <Content style={{ overflow: "initial", height: "100vh" }}>
                        {props.children}
                        <IncomingCallModal
                            isOpen={appContext.incomingCall}
                            handleRejectCall={handleRejectCall}
                            handleAcceptCall={handleAcceptCall}
                            //@ts-ignore
                            imageProfileURL={imageProfileURL}
                            displayName={displayName}
                        />
                    </Content>
                </Layout>
            </Layout>
            <BoxDetailFileDownload></BoxDetailFileDownload>
        </>
    );
}

function CustomLinkIcon({
    to,
    activeOnlyWhenExact,
    children,
    title,
    noti,
    isCusttomSrc,
}: {
    to: any;
    activeOnlyWhenExact: any;
    children: any;
    title: any;
    noti: any;
    isCusttomSrc: any;
}) {
    const appContext: any = useContext(AppContext);
    const [hover, setHover] = useState(false);
    let navigate = useNavigate();
    let location = useLocation();
    let match = false;
    let useTo = to;
    if (!checkEmpty(to?.pathname)) {
        useTo = to?.pathname;
    }
    if (to === location.pathname || useTo == appContext.mainMenuActive) {
        match = true;
    }


    if (to === pathRoutes.citizenprofile) {
        return (
            <Tooltip placement="right" title={title} color="#0f4c82">
                <div
                    className={styles.linkHover}
                    onClick={() => {
                        appContext.setMainMenuActive(useTo);
                        navigate(pathRoutes.citizenprofile);
                    }}
                    onMouseOver={() => {
                        setHover(true);
                    }}
                    onMouseLeave={() => {
                        setHover(false);
                    }}
                >
                    <div
                        style={{ color: match ? "#428dff" : "white", position: "relative" }}
                    >
                        {isTrue(isCusttomSrc) ? (
                            <>
                                <div className={styles.boxActive}>
                                    {children}
                                    {(match || hover) && (
                                        <span className={styles.spanActive}></span>
                                    )}
                                </div>
                            </>
                        ) : (
                            children
                        )}
                    </div>
                </div>
            </Tooltip>
        );
    } else {
        return (
            <Tooltip placement="right" title={title} color="#0f4c82">
                <div
                    onMouseOver={() => {
                        setHover(true);
                    }}
                    onMouseLeave={() => {
                        setHover(false);
                    }}
                    onClick={() => {
                        appContext.setMainMenuActive(useTo);
                    }}
                >
                    <Link to={to} className={styles.linkHover}>
                        <div
                            style={{
                                color: match ? "#428dff" : "white",
                                position: "relative",
                            }}
                        >
                            {noti > 0 && <div className={styles.noti}>{noti}</div>}
                            {isTrue(isCusttomSrc) ? (
                                <>
                                    <div className={styles.boxActive}>
                                        {children}
                                        {(match || hover) && (
                                            <span className={styles.spanActive}></span>
                                        )}
                                    </div>
                                </>
                            ) : (
                                children
                            )}
                        </div>
                    </Link>
                </div>
            </Tooltip>
        );
    }
}

function CustomLinkMenuIcon({
    key,
    to,
    activeOnlyWhenExact,
    title,
    noti,
    isCustomSrc,
    collapsed,
    icon
}: {
    to: any;
    key: string;
    activeOnlyWhenExact: any;
    title: any;
    noti: any;
    isCustomSrc: any;
    collapsed: any;
    icon: any
}) {
    let match = false;
    const { t } = useTranslation()
    const appContext: any = useContext(AppContext);
    const navigate = useNavigate();
    const [hover, setHover] = useState(false);
    const location = useLocation();

    let useTo = to;

    if (!checkEmpty(to?.pathname)) {
        useTo = to?.pathname;
    }

    useEffect(() => {
        console.log("menu key", to)
    }, [to])


    if (to === location.pathname || useTo == appContext.mainMenuActive) {
        match = true;
    }

    const onClick = () => {
        navigate(to);
    }

    return (
        <Menu.Item
            id={key}
            key={to}
            style={{ padding: collapsed ? "3px 14px" : "", paddingLeft: "14px" }}
            title={t(title)}
            icon={icon}
            onClick={onClick}
        >
            {t(title)}
        </Menu.Item>
    );
}

function CustomLinkIconText({
    to,
    activeOnlyWhenExact,
    children,
}: {
    to: any;
    activeOnlyWhenExact: any;
    children: any;
}) {
    const appContext: any = useContext(AppContext);
    let location = useLocation();
    let match = false;
    if (to === location.pathname) {
        match = true;
    }

    useEffect(() => {
        console.log("appContext.mainMenuActive:", appContext.mainMenuActive)
        console.log("to:", to)
    }, [appContext.mainMenuActive])

    return (
        <Link
            className={
                match ? styles.boxMenuActiveInside : styles.boxMenuDefaultInside
            }
            to={to}
        >
            <div
                onClick={() => {
                    appContext.setMainMenuActive(to);
                }}
            >
                {children}
            </div>
        </Link>
    );
}

function CustomLinkIconTextGear({
    to,
    activeOnlyWhenExact,
    children,
}: {
    to: any;
    activeOnlyWhenExact: any;
    children: any;
}) {
    const appContext: any = useContext(AppContext);
    let location = useLocation();
    let match = false;
    if (to === location.pathname) {
        match = true;
    }

    return (
        <Link
            className={
                match ? styles.boxGearMenuActiveInside : styles.boxGearMenuDefaultInside
            }
            to={to}
        >
            <div
                onClick={() => {
                    appContext.setMainMenuActive(to);
                }}
            >
                {children}
            </div>
        </Link>
    );
}
